import { IndividualRole, ModulesEnableOptions } from '@aslanpay/portal-common-lib';

export const canAccessModule = (
  status: ModulesEnableOptions | undefined,
  role: IndividualRole | undefined
) => status === 'ENABLED' || (role === 'COMPANY_ADMIN' && status === 'DISABLED');
